import React from 'react';
import { useEvent } from '../../../../data/hooks/eventHooks';
import LoadExhibitors from '../../../loaders/LoadExhibitors';
import LoadLeads from '../../../loaders/LoadLeads';
import ErrorBoundary from '../../../validate/ErrorBoundary';
import WaitWhileBusy from '../../../WaitWhileBusy';
import Screen from '../../Screen';
import LeadsContent from './LeadsContent';
import LeadsFooter from './LeadsFooter';
import LeadsHeader from './LeadsHeader';

function EventLeadsScreen(props) {
    const { eventId, tab } = props,
        event = useEvent(eventId);

    const header = <LeadsHeader event={event} tab={tab} />,
        footer = <LeadsFooter event={event} />;

    return (
        <Screen header={header} footer={footer}>
            <LeadsContent eventId={eventId} tab={tab} />
        </Screen>
    );
}

export default (props) => (
    <ErrorBoundary altRoute="../..">
        <LoadLeads eventId={props.match.params.eventId}>
            <LoadExhibitors eventId={props.match.params.eventId}>
                <WaitWhileBusy>
                    <EventLeadsScreen {...props.match.params} />
                </WaitWhileBusy>
            </LoadExhibitors>
        </LoadLeads>
    </ErrorBoundary>
);
